import { render, staticRenderFns } from "./result-tab.vue?vue&type=template&id=1cd9cc73&scoped=true&"
import script from "./result-tab.vue?vue&type=script&lang=js&"
export * from "./result-tab.vue?vue&type=script&lang=js&"
import style0 from "./result-tab.vue?vue&type=style&index=0&id=1cd9cc73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd9cc73",
  null
  
)

export default component.exports